export default __webpack_public_path__ + "static/media/defaultGalleryItem.5b350b2f.svg";